import { ensureSession } from './session';
import { API_BASE_URL } from './config';

export async function apiFetch(path, options = {}, { retried } = {}) {
  await ensureSession({ force: retried });
  const csrfToken = document.cookie
    .split('; ')
    .find((cookie) => cookie.startsWith('csrf_token='))
    ?.slice('csrf_token='.length);

  const { headers: callerHeaders, ...restOptions } = options;

  const headers = {
    'X-CSRF-Token': csrfToken,
    ...callerHeaders,
  };

  // Only set default Content-Type for JSON bodies.
  // For FormData (file uploads), let the browser auto-set
  // the correct multipart/form-data boundary.
  if (!headers['Content-Type'] && !(restOptions.body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
  }

  let response = await fetch(`${API_BASE_URL}${path}`, {
    credentials: 'include',
    headers,
    ...restOptions,
  });

  // If the session was lost (e.g. session cookie deleted but CSRF token
  // still present), force a fresh session init and retry once.
  if (response.status === 401 && !retried) {
    response = await apiFetch(path, options, { retried: true });
  }

  return response;
}
